import React, { useState, useEffect } from "react";
import { FlatCard } from "components/UI-lib";
import { renderMarkdown } from "./markdownRenderer";

interface MarkdownRenderer {
  markdownUrl: string;
}

const MarkdownRenderer: React.FC<MarkdownRenderer> = ({ markdownUrl }) => {
  const [markdown, setMarkdown] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMarkdown = async () => {
      const fetchFromUrl = async (url: string) => {
        const response = await fetch(
          "https://us-central1-brev-testing-1.cloudfunctions.net/cors-proxy",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ url }),
          }
        );
        return response.text();
      };

      const isNotFound = (text: string) => text === "404: Not Found";

      try {
        // Try fetching from the original URL
        const text = await fetchFromUrl(markdownUrl);

        if (!isNotFound(text)) {
          setMarkdown(text);
          return;
        }

        // If not found, try fallback URL (replace /main/ with /master/)
        const fallbackUrl = markdownUrl.replace("/main/", "/master/");
        const fallbackText = await fetchFromUrl(fallbackUrl);

        if (isNotFound(fallbackText)) {
          setError("404: Not Found");
          return;
        }

        setMarkdown(fallbackText);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMarkdown();
  }, [markdownUrl]);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">Loading...</div>
    );
  }

  if (error) {
    return <div>Error loading markdown: {error}</div>;
  }

  return (
    <FlatCard>
      <div
        className="max-w-none"
        dangerouslySetInnerHTML={{ __html: renderMarkdown(markdown) }}
      />
    </FlatCard>
  );
};

export default MarkdownRenderer;
